import { gql } from '@apollo/client';

import { INNOVATION } from './innovation';
import { INTRAPRENEUR_CHALLENGE_BASIC } from './intrapreneur-challenge';
import { REGION } from './region';
import { TOPIC } from './topic';
import { FILE } from './upload';
import { USER_BASICS } from './user';

export const SUGGEST_IDEA = gql`
  mutation SuggestIdea($type: SuggestionItemType, $id: String!) {
    suggest(type: $type, id: $id)
  }
`;

export const CREATE_IDEA_CHALLENGE_INVITE = gql`
  mutation CreateIdeaChallengeInvite($challengeId: UUID!, $ideaId: UUID!) {
    createIdeaChallengeInvite(challengeId: $challengeId, ideaId: $ideaId) {
      ideaId
    }
  }
`;

/**
 * Lists suggestion results for a given item.
 * Returns details about suggested matches including internal challenges, ideas,
 * reasoning for the match, match score, and any associated invites.
 *
 * @param id - The ID of the item to get suggestions for
 * @param type - The type of item ('IDEA' | 'CHALLENGE' | 'COMPANY' | 'OPEN_CHALLENGE' | 'CRUNCHBASE_CHALLENGE')
 * @param page - Page number for pagination
 * @param limit - Number of results per page
 */
export const GET_IDEA_SUGGESTION = gql`
  query ListSuggestionResults(
    $id: String!
    $type: SuggestionItemType!
    $page: Int
    $limit: Int
  ) {
    listSuggestionResults(id: $id, type: $type, page: $page, limit: $limit) {
      candidateResponses {
        internalChallenge {
          ...intrapreneurChallengeBasic
        }
        idea {
          id
          name
          coverPhoto {
            ...file
          }
          coverPhotoUrl {
            author
            profileUrl
            imageUrl
          }
          topics {
            ...topic
          }
          createdBy {
            ...userBasics
          }
          createdAt
        }
        company {
          id
          name
          logo {
            ...file
          }
          description
          companyInfo {
            website
            linkedin
          }
        }
        reasoning
        score
        invite {
          id
          newIdeaId
          status
        }
      }
      total
    }
  }
  ${INTRAPRENEUR_CHALLENGE_BASIC}
  ${USER_BASICS}
  ${FILE}
  ${REGION}
  ${INNOVATION}
  ${TOPIC}
`;

/**
 * Checks the suggestion status for a given primary item.
 *
 * @param primaryId - The ID of the primary item
 * @param primaryType - The type of the primary item ('IDEA' | 'CHALLENGE' | 'COMPANY' | 'OPEN_CHALLENGE' | 'CRUNCHBASE_CHALLENGE')
 * @returns The suggestion status ('IN_PROGRESS' | 'NONE' | 'DONE')
 */
export const CHECK_SUGGESTION_STATUS = gql`
  query CheckSuggestionStatus(
    $primaryId: String!
    $primaryType: SuggestionItemType!
  ) {
    checkSuggestionStatus(primaryId: $primaryId, primaryType: $primaryType)
  }
`;

export const GET_SUGGESTION_KEYWORDS = gql`
  query GetKeyword($resourceId: String, $type: SuggestionItemType) {
    getKeyword(resourceId: $resourceId, type: $type) {
      keywords
    }
  }
`;

export const COPY_IDEA = gql`
  mutation IdeaCopy($challengeId: UUID!, $ideaId: UUID!) {
    ideaCopy(challengeId: $challengeId, ideaId: $ideaId) {
      id
      name
    }
  }
`;

export const UPDATE_KEYWORDS = gql`
  mutation UpdateKeywords(
    $keywords: [String]
    $resourceId: String!
    $type: SuggestionItemType!
  ) {
    updateKeywords(keywords: $keywords, resourceId: $resourceId, type: $type) {
      id
      keywords
    }
  }
`;

export const RESPOND_IDEA_CHALLENGE_INVITE = gql`
  mutation RespondIdeaChallengeInvite(
    $id: UUID!
    $status: IdeaChallengeInviteStatus!
  ) {
    respondIdeaChallengeInvite(id: $id, status: $status) {
      id
      ideaId
      newIdeaId
      status
      createdBy
      challenge {
        id
        title
      }
    }
  }
`;
